import React from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { useDispatch, useSelector } from "react-redux";

export default function MyTabs() {
  const SelecedExchange = useSelector((state) => state.SetExchange);
  const SelectedDropdownOption = useSelector(
    (state) => state.SelectedDropdownOption
  );
  const selectedAnalytics = useSelector((state) => state.selectedAnalytics);

  const dispatch = useDispatch();
  const handleChange = (event, newValue) => {
    dispatch({ type: "SET_EXCHANGE", payload: newValue });
  };

  if (SelectedDropdownOption === "Volume_Analysis") {
    dispatch({ type: "SET_EXCHANGE", payload: "" });
  }
  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={SelecedExchange}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList
            onChange={handleChange}
            aria-label="lab API tabs example"
            TabIndicatorProps={{
              style: {
                backgroundColor:
                  SelectedDropdownOption === "Volume_Analysis"
                    ? "transparent"
                    : "grey",
              },
            }}
          >
            <Tab
              label="NSE"
              value="NSE"
              sx={{
                fontSize: "16px",
                borderRadius: "10px",
                backgroundColor:
                  SelectedDropdownOption === "Volume_Analysis"
                    ? "#e6eeff"
                    : SelecedExchange === "NSE"
                    ? "#ccdcff"
                    : "#e6eeff",
                fontWeight: "bold",
                color:
                  SelectedDropdownOption === "Volume_Analysis"
                    ? "white"
                    : SelecedExchange === "NSE"
                    ? "#333333"
                    : "white",
                height: "20px",
                minHeight: "44px",
                marginRight: "10px",
                "&.Mui-selected": {
                  backgroundColor:
                    SelectedDropdownOption === "Volume_Analysis"
                      ? "#e6eeff"
                      : "#ccdcff",
                  color:
                    SelectedDropdownOption === "Volume_Analysis"
                      ? "white"
                      : "#333333",
                },
              }}
              disabled={SelectedDropdownOption === "Volume_Analysis"}
            />
            <Tab
              label="BSE"
              value="BSE"
              sx={{
                fontSize: "16px",
                borderRadius: "10px",
                backgroundColor:
                  SelectedDropdownOption === "Volume_Analysis"
                    ? "#e6eeff"
                    : SelecedExchange === "BSE"
                    ? "#ccdcff"
                    : "#e6eeff",
                fontWeight: "bold",
                color:
                  SelectedDropdownOption === "Volume_Analysis"
                    ? "#white"
                    : SelecedExchange === "BSE"
                    ? "#333333"
                    : "white",
                height: "20px",
                minHeight: "44px",
                "&.Mui-selected": {
                  backgroundColor:
                    SelectedDropdownOption === "Volume_Analysis"
                      ? "#e6eeff"
                      : "#ccdcff",
                  color:
                    SelectedDropdownOption === "Volume_Analysis"
                      ? "white"
                      : "#333333",
                },
              }}
              disabled={
                SelectedDropdownOption === "Volume_Analysis" ||
                selectedAnalytics === "intraday-analytics"
              }
            />
          </TabList>
        </Box>
      </TabContext>
    </Box>
  );
}
